import { render } from "./tutorial.vue?vue&type=template&id=1e6a224b&scoped=true"
import script from "./tutorial.vue?vue&type=script&lang=js"
export * from "./tutorial.vue?vue&type=script&lang=js"

import "./tutorial.vue?vue&type=style&index=0&id=1e6a224b&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6a224b"]])

export default __exports__